import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store';

const safeSelector = (state: RootState) => state.attendees;

export const attendeesListSelector = createSelector(safeSelector, (attendees) => attendees.data);

export const attendeeWorkflowListSelector = createSelector(
  safeSelector,
  (attendees) => attendees.attendeeWorkflows
);

export const attendeeSelector = createSelector(safeSelector, (attendees) => attendees.current);

export const attendeesIsLoadingSelector = createSelector(
  safeSelector,
  (attendees) => attendees.isAttendeesLoading
);

export const attendeesStatsIsLoadingSelector = createSelector(
  safeSelector,
  (attendees) => attendees.isAttendeesStatsLoading
);

export const orderSelector = createSelector(safeSelector, (attendees) => attendees.order);

export const orderLoadingSelector = createSelector(
  safeSelector,
  (attendees) => attendees.isOrderLoading
);

export const attendeeMonthlyTransactionsSelector = createSelector(
  safeSelector,
  (attendees) => attendees.attendeeMonthlyTransactions
);

export const attendeeDailyTransactionsSelector = createSelector(
  safeSelector,
  (attendees) => attendees.attendeeDailyTransactions
);

export const attendeeInsightsLoadingSelector = createSelector(
  safeSelector,
  (attendees) => attendees.isInsightsLoading
);

export const moreAttendeesLoadingSelector = createSelector(
  safeSelector,
  (attendees) => attendees.isMoreAttendeesLoading
);

export const attendeeWaitlistSelector = createSelector(
  safeSelector,
  (attendees) => attendees.attendeeWaitlist
);

export const emailActivitiesSelector = createSelector(
  safeSelector,
  (attendees) => attendees.emailActivity
);

export const attendeeActivitiesSelector = createSelector(
  safeSelector,
  (attendees) => attendees.attendeeActivities
);

export const attendeeActivitiesLoadingSelector = createSelector(
  safeSelector,
  (attendees) => attendees.attendeeActivitiesLoading
);

export const attendeeTicketsSelector = createSelector(
  safeSelector,
  (attendees) => attendees.attendeeTickets
);

export const attendeeTicketsLoadingSelector = createSelector(
  safeSelector,
  (attendees) => attendees.isAttendeeTicketsLoading
);
